import { flow } from 'es-toolkit';
import { fetchMeWithFavorites } from '../../actions/me';
import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import connectAsync from '../../utils/connectAsync';
import FavoritesRoute from './FavoritesRoute';

export default flow(
  withAdScreenRequest(() => null),
  connectAsync([fetchMeWithFavorites]),
)(FavoritesRoute);
